import { format, formatDistance } from "date-fns";
import LoadingPage from "../../../../reusableComponents/loader/loadingPage";
import { editModeOn} from "../../../../utilFunctions";
import { DATE_FORMAT, functionalities } from "../../../../consts";
import TextTruncate from "../../../../utilsComponent/textTruncate";
import { useEffect, useState } from "react";
import MedicalReviewRequest from "./MedicalReviewRequest";
import "../Investigation/investigation.scss";
import NoDataFound from "../../../../utilsComponent/noDataFound";
import CloseMedicalReviewForm from "./CloseMedicalReviewForm";
import DocumentSliderModal from "../../../../utilsComponent/DocumentSliderModal";
import { fetchRemarksAndDocuments, fetchReportDocuments} from "../Investigation/investigationHelper";
import RemarksAndDocumentsModal from "../Investigation/RemarksAndDocumentsModal";
import { Tooltip } from "react-bootstrap";
import { getIsShowButton } from "../Service/apiHelper";

const MedicalReviewDetails = ({
  medicalReviewList,
  loading,
  claimDetails,
  roleDataCookie,
  setNotified,
  activeTab
}) => {

const [showModal, setShowModal] = useState(false);
const [modalData, setModalData] = useState({
  medicalReview: null,
  actionType: "", // "add", "close"
});
const [showRemarksModal, setShowRemarksModal] = useState(false);
const [selectedRemarks, setSelectedRemarks] = useState([]);
const [allDocuments, setAllDocuments] =useState([])
const [selectedDocuments, setSelectedDocuments] = useState([]);
const [loadingRequest, setLoadingRequest] = useState(false);
const [showDocumentModal, setShowDocumentModal] = useState(false);
const [currentDocIndex, setCurrentDocIndex] = useState(0);
const [activeIndex, setActiveIndex] = useState();
const [medicalReviewTitle, setMedicalReviewTitle] = useState('');
const [showUpdatedRemarks, setShowUpdatedRemarks]  = useState(false);

const handleOpenCloseModal = (medicalReview, actionType) => {
  setShowModal(false);
  setTimeout(() => {
    setModalData({ medicalReview, actionType });
    setShowModal(true);
  }, 100);
};

const closeModal = () => {
  setShowModal(false);
};

useEffect(() => {
  if (activeTab !== "MEDICAL REVIEW") {
    setActiveIndex(undefined);
    setSelectedRemarks([]);
    setAllDocuments([]);
    setShowRemarksModal(false);
    setMedicalReviewTitle("");
  }
}, [activeTab]);

const handleViewRemarksAndDocuments = async (medicalReview, index) => {
  setLoadingRequest(true);
  try {
    const isActive = activeIndex === index;
    const { remarks, documents } = isActive ? { remarks: [], documents: [] } : await fetchRemarksAndDocuments(medicalReview);

    setSelectedRemarks(remarks);
    setAllDocuments(documents);
    setShowRemarksModal(!isActive);
    setMedicalReviewTitle(isActive ? `` : `Medical Review - ${medicalReview.investigationId}`);
    setActiveIndex(isActive ? undefined : index);
  } catch (error) {
    // Error already logged in helper
  } finally {
    setLoadingRequest(false);
    closeModal();
  }
};

const handleViewReport = async (medicalReview) => {
  try {
    const documents = await fetchReportDocuments(medicalReview);

    if (documents.length > 0) {
      setSelectedDocuments(documents);
      setCurrentDocIndex(0);
      setShowDocumentModal(true);
    }
  } catch (error) {
    // Error already logged in helper
  }
};

  useEffect(() => {   
    if(showUpdatedRemarks) {
      if(showRemarksModal) {
        handleViewRemarksAndDocuments(modalData?.medicalReview, activeIndex);
      }
      setShowUpdatedRemarks(false);
    }
  },[showUpdatedRemarks])


  return (
    <>
      <div className="d-flex align-items-end justify-content-between">
        <h3 className="heading_h2History ms-3 mt-4" id="historyHistory">
          Medical Review Records
        </h3>
        {editModeOn(functionalities.MEDICAL_REVIEW_TAB) && claimDetails?.status?.toLowerCase() !== "close" && getIsShowButton(claimDetails?.subStatus)
                        &&  (
          <MedicalReviewRequest
            id={claimDetails?.claimId}
            setNotified={setNotified}
            claimDetails={claimDetails}
            modalData={modalData}
            medicalReviewList={medicalReviewList}
            roleDataCookie={roleDataCookie}
          />
        )}
      </div>

      <div className="row">
        <section className="p-4 pt-0 table-responsive">
          {loading ? (
            <LoadingPage kshemaLoader/>
          ) : medicalReviewList && medicalReviewList.length !== 0 ? (
            <div className="overflowGIS scrollbar">
              <table id="claim_historyField">
                <thead>
                  <tr className="sticky-header">
                    <th>Medical Review Id</th>
                    <th>Agency Name</th>
                    <th>Reviewer Name</th>
                    <th>Reason for Medical Review</th>
                    <th>Medical Review Initiated By</th>
                    <th>MR Initiated Date & Time</th>
                    <th>MR Completed Date & Time</th>
                    <th>Aging</th>
                    <th>Closing Remarks</th>
                    <th>Report</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {medicalReviewList.map((medicalReview, index) => (
                    <>
                      <tr key={index}>
                        <td className="centerField">
                          <span
                            className="text-primary pointer"
                            onClick={() => {
                              handleViewRemarksAndDocuments(medicalReview, index);
                            }}
                          >{medicalReview.investigationId || "--"}</span>
                        </td>
                        <td className="centerField">
                          <span>{medicalReview.vendorName || "--"}</span>
                        </td>
                        <td className="centerField">
                          <span
                          >
                            {medicalReview.investigatorName || "--"}
                          </span>
                        </td>
                        <td className="centerField">
                          <TextTruncate
                            text={medicalReview.reasonForInvestigation || "--"}
                            length={30}
                          />
                        </td>
                        {/* claimDetails?.claimHandler  */}
                        <td className="centerField">
                          <span>{ medicalReview?.investigationRequestedBy || '---'}</span> 
                        </td>                      
                        <td className="centerField">
                          {medicalReview.investigationInitiatedDate
                            ? format(
                                new Date(medicalReview.investigationInitiatedDate),
                                DATE_FORMAT.DD_MM_YYYY_HH_MM
                              )
                            : "--"}
                        </td>
                        <td className="centerField">
                          {medicalReview.investigationCompletedDate
                            ? format(
                                new Date(
                                  medicalReview.investigationCompletedDate),
                                 DATE_FORMAT.DD_MM_YYYY_HH_MM
                              )
                            : "--"}
                        </td>
                        <td className="centerField">
                          {medicalReview.investigationInitiatedDate &&
                          medicalReview.investigationCompletedDate
                            ? formatDistance(
                                new Date(
                                  medicalReview.investigationInitiatedDate
                                ),
                                new Date(
                                  medicalReview.investigationCompletedDate
                                )
                              )
                            : medicalReview.investigationInitiatedDate
                            ? formatDistance(
                                new Date(
                                  medicalReview.investigationInitiatedDate
                                ),
                                new Date()
                              )
                            : "--"}
                        </td>
                       <td className="centerField">
                         <TextTruncate text={medicalReview.remarks ? JSON.parse(medicalReview.remarks).find(medicalReview => medicalReview.status === "close")?.remarks || "--": "--"}
                            length={30} />
                        </td>
                        <td className="centerField">
                          <span
                            className="text-primary pointer"
                            onClick={(e) => {
                              e.preventDefault();
                              handleViewReport(medicalReview);
                            }}
                          >
                            View Report
                          </span>
                        </td>
                       <td className="centerField">
                        <span
                        className={`me-2 text-decoration-none ${medicalReview?.investigationStatus.toLowerCase()  === 'closed' || !editModeOn(functionalities.MEDICAL_REVIEW_TAB) ? 'text-muted' : 'text-primary pointer'}`}
                        onClick={(e) => {
                          if (editModeOn(functionalities.MEDICAL_REVIEW_TAB) && medicalReview?.investigationStatus.toLowerCase()  !== 'closed') {
                            e.preventDefault();
                            handleOpenCloseModal(medicalReview, 'add');
                          }
                        }}
                        >
                        Add Remarks
                        </span>

                        <span
                        className={`text-decoration-none ${medicalReview?.investigationStatus.toLowerCase()  === 'closed' || !editModeOn(functionalities.MEDICAL_REVIEW_TAB) ? 'text-muted' : 'text-primary pointer'}`}
                        onClick={(e) => {
                          if (editModeOn(functionalities.MEDICAL_REVIEW_TAB) && medicalReview?.investigationStatus.toLowerCase()  !== 'closed') {
                            e.preventDefault();
                            handleOpenCloseModal(medicalReview, 'close');
                          }
                        }}
                        >
                        Close Medical Review
                        </span>
                        </td>
                      </tr>
                    </>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <NoDataFound text="No Data Found" />
          )}
        </section>
      </div>

      
      {/* {medicalReviewList[activeIndex]?.remarks?.length > 0 && showRemarksModal && typeof activeIndex === 'number' && ( */}
      {showRemarksModal && (
        <RemarksAndDocumentsModal
          remarks={selectedRemarks?.filter((remark) => {return remark?.status === 'add'})}
          closingRemarks={selectedRemarks?.filter((remark) => {return remark?.status === 'close'})}
          documents={allDocuments}
          title={medicalReviewTitle}
          roleDataCookie= {roleDataCookie}
          onDocumentClick={(docs) => {
            setSelectedDocuments(docs)
              setCurrentDocIndex(0);
              setShowDocumentModal(true);
            }}
        />
      )}

      {showModal && (
        <div id="modal-overlay" className="text-start">
          <CloseMedicalReviewForm
            onClose={closeModal}
            modalData={modalData}
            claimDetails={claimDetails}
            roleDataCookie={roleDataCookie}
            setShowUpdatedRemarks={setShowUpdatedRemarks}
            setNotified={setNotified}
            heading={
              modalData.actionType === "add"
                ? "Add Remarks"
                : "Close Medical Review"
            }
            loading={loadingRequest} // Pass the loading state as a prop
            onSubmit={handleViewRemarksAndDocuments} // Pass a new function to handle the submission
          />
        </div>
      )}

      {showDocumentModal && (
        <DocumentSliderModal
          show={showDocumentModal}
          onClose={() => setShowDocumentModal(false)}
          documents={selectedDocuments}
          currentIndex={currentDocIndex}
          setCurrentIndex={setCurrentDocIndex}
        />

      )}
    </>
  );
};

export default MedicalReviewDetails;
